export default [
  					
  // { name: '首頁 ', imgSrc: '', subTitle: '', section: 'section1', svgSrc: '', offset: 0 },
  { name: '來電洽詢', imgSrc: '', subTitle: '', section: 'contact', svgSrc: '', offset: 700 },
  { name: '立即預約', imgSrc: '', subTitle: '', section: 'contact', svgSrc: '', offset: 0 },
  { name: '地圖導航', imgSrc: '', subTitle: '', section: 'google-map', svgSrc: '', mobileOffset: 0, offset: -150 },
  // { name: '立即預約', imgSrc: '', subTitle: '', section: 'contact', svgSrc: '', mobileOffset: 0, offset: 0 },
]
